import React from "react";
import ReactDOM from "react-dom/client";
import App from "./layout/App";
import "dayjs/locale/cs";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

console.log("Application is running in version " + import.meta.env.VITE_PACKAGE_VERSION);
